import React from 'react';

const LoadingLogin = () => {
  return (
    <div className="login-loading">
      <div className="login-spinner">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <p>Signing in...</p>
      
      <style jsx>{`
        .login-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          color: white;
          text-align: center;
        }
        
        .login-spinner {
          display: flex;
          gap: 6px;
          margin-bottom: 16px;
        }
        
        .dot {
          width: 10px;
          height: 10px;
          background: #e74c3c;
          border-radius: 50%;
          animation: bounce 1.4s infinite ease-in-out both;
        }
        
        .dot:nth-child(1) {
          animation-delay: -0.32s;
        }
        
        .dot:nth-child(2) {
          animation-delay: -0.16s;
        }
        
        .dot:nth-child(3) {
          animation-delay: 0s;
        }
        
        p {
          margin: 0;
          font-size: 14px;
          color: #8892b0;
          font-weight: 500;
        }
        
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingLogin;